import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';
import { RankingVistoriador } from '../interfaces/ranking-vistoriador.interface';
import { environment } from '../../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class FinanceiroService {
	private apiUrl = `${environment.cedaeapp}`;

	constructor(private http: HttpClient) { }

	getRelatoriosVistorias(filters: {
		DataInicial?: string | null,
		DataFinal?: string | null,
		NumeroOS?: string | null,
		NomeConsumidor?: string | null,
		CpfOuCnpj?: string | null,
		StatusOS?: string | null,
		Cep?: string | null,
		Logradouro?: string | null,
		Numero?: string | null,
		Bairro?: string | null,
		Cidade?: string | null,
		Estado?: string | null
	} = {}): Observable<any> {
		const token = localStorage.getItem('token');
		const headers = new HttpHeaders({
			'Authorization': `Bearer ${token}`,
			'Content-Type': 'application/json'
		});

		let params = new HttpParams();

		// Ajuste de datas: se informadas sem hora, normaliza para inicio/fim do dia
		if (filters.DataInicial) {
			let d = filters.DataInicial as string;
			if (d.indexOf('T') === -1) d = `${d}T00:00:00`;
			params = params.set('DataInicial', d);
		}
		if (filters.DataFinal) {
			let d = filters.DataFinal as string;
			if (d.indexOf('T') === -1) d = `${d}T23:59:59`;
			params = params.set('DataFinal', d);
		}

		const optionalStringFields = ['NumeroOS','NomeConsumidor','CpfOuCnpj','StatusOS','Cep','Logradouro','Numero','Bairro','Cidade','Estado'];
		for (const key of optionalStringFields) {
			const val = (filters as any)[key];
			if (val !== undefined && val !== null && String(val).trim() !== '') {
				params = params.set(key, String(val).trim());
			}
		}

		const url = `${this.apiUrl}/relatorio/relatorios-vistorias`;

		return this.http.get<any>(url, { headers, params }).pipe(
			map(resp => resp ?? []),
			catchError(err => {
				if (err.status === 404) return of([]);
				throw err;
			})
		);
	}

	getRelatorioGeral(filters: {
		DataInicial?: string | null,
		DataFinal?: string | null,
		NumeroOS?: string | null,
		NomeConsumidor?: string | null,
		CpfOuCnpj?: string | null,
		StatusOS?: string | null,
		Cep?: string | null,
		Logradouro?: string | null,
		Numero?: string | null,
		Bairro?: string | null,
		Cidade?: string | null,
		Estado?: string | null,
		TipoVistoria?: string | null
	} = {}): Observable<any> {
		const token = localStorage.getItem('token');
		const headers = new HttpHeaders({
			'Authorization': `Bearer ${token}`,
			'Content-Type': 'application/json'
		});

		let params = new HttpParams();

		if (filters.DataInicial) {
			let d = filters.DataInicial as string;
			if (d.indexOf('T') === -1) d = `${d}T00:00:00`;
			params = params.set('DataInicial', d);
		}
		if (filters.DataFinal) {
			let d = filters.DataFinal as string;
			if (d.indexOf('T') === -1) d = `${d}T23:59:59`;
			params = params.set('DataFinal', d);
		}

		const optionalStringFields = ['NumeroOS','NomeConsumidor','CpfOuCnpj','StatusOS','Cep','Logradouro','Numero','Bairro','Cidade','Estado','TipoVistoria'];
		for (const key of optionalStringFields) {
			const val = (filters as any)[key];
			if (val !== undefined && val !== null && String(val).trim() !== '') {
				params = params.set(key, String(val).trim());
			}
		}

		const url = `${this.apiUrl}/relatorio/relatorio-geral`;

		return this.http.get<any>(url, { headers, params }).pipe(
			map(resp => resp ?? {}),
			catchError(err => {
				if (err.status === 404) return of({});
				throw err;
			})
		);
	}

	getRankingVistoriadores(filters: {
		DataInicial?: string | null,
		DataFinal?: string | null
	} = {}): Observable<RankingVistoriador[]> {
		const token = localStorage.getItem('token');
		const headers = new HttpHeaders({
			'Authorization': `Bearer ${token}`,
			'Content-Type': 'application/json'
		});

		let params = new HttpParams();

		if (filters.DataInicial) {
			let d = filters.DataInicial as string;
			if (d.indexOf('T') === -1) d = `${d}T00:00:00`;
			params = params.set('DataInicial', d);
		}
		if (filters.DataFinal) {
			let d = filters.DataFinal as string;
			if (d.indexOf('T') === -1) d = `${d}T23:59:59`;
			params = params.set('DataFinal', d);
		}

		const url = `${this.apiUrl}/relatorio/ranking-vistoriadores`;

		return this.http.get<RankingVistoriador[]>(url, { headers, params }).pipe(
			map(resp => resp ?? []),
			catchError(err => {
				if (err.status === 404) return of([]);
				throw err;
			})
		);
	}
}
